module.exports = __webpack_public_path__ + "37becd365e7ef2e158ac5ade09a5e0c2.woff";